import React from "react";

const ZoomFitIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43 29C43 36.732 36.732 43 29 43C21.268 43 15 36.732 15 29C15 21.268 21.268 15 29 15C36.732 15 43 21.268 43 29ZM39.5846 40.9988C36.7639 43.489 33.0584 45 29 45C20.1634 45 13 37.8366 13 29C13 20.1634 20.1634 13 29 13C37.8366 13 45 20.1634 45 29C45 33.0584 43.489 36.7639 40.9988 39.5846L48.7071 47.2929C49.0976 47.6834 49.0976 48.3166 48.7071 48.7071C48.3166 49.0976 47.6834 49.0976 47.2929 48.7071L39.5846 40.9988Z"
          fill="#4D4D4D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33 22C33 21.4477 32.5523 21 32 21C31.4477 21 31 21.4477 31 22V24C31 25.6569 32.3431 27 34 27H36C36.5523 27 37 26.5523 37 26C37 25.4477 36.5523 25 36 25H34C33.4477 25 33 24.5523 33 24V22ZM22 31H24C25.6569 31 27 32.3431 27 34V36C27 36.5523 26.5523 37 26 37C25.4477 37 25 36.5523 25 36V34C25 33.4477 24.5523 33 24 33H22C21.4477 33 21 32.5523 21 32C21 31.4477 21.4477 31 22 31ZM31 34C31 32.3431 32.3431 31 34 31H36C36.5523 31 37 31.4477 37 32C37 32.5523 36.5523 33 36 33H34C33.4477 33 33 33.4477 33 34V36C33 36.5523 32.5523 37 32 37C31.4477 37 31 36.5523 31 36V34ZM26 21C26.5523 21 27 21.4477 27 22V24C27 25.6569 25.6569 27 24 27H22C21.4477 27 21 26.5523 21 26C21 25.4477 21.4477 25 22 25H24C24.5523 25 25 24.5523 25 24V22C25 21.4477 25.4477 21 26 21Z"
          fill="#FF5F30"
        />
      </g>
    </svg>
  );
};

export default ZoomFitIcon;
